



import {Component, Vue} from 'vue-property-decorator';
import AuthCard from "@/components/Organisms/AuthCard/AuthCard.vue";
import BgAvtBaby from "@/components/Atoms/AvtBaby/AvtBaby.vue";
import ButtonSuccessful from "@/components/Atoms/ButtonSuccessful/ButtonSuccessful.vue";

@Component({
  components: {
    AuthCard,
    ButtonSuccessful,
    BgAvtBaby
  }
})
export default class TutorialStart extends Vue {
  private tutorialAvt = require('@/assets/images/bg-baby.png')
  private babyId = this.$route.params.id

  private onClickStartTutorial() {
    this.$router.push({name: 'routes.tutorial', params: {id: this.babyId}})
  }
}
